export { default } from './category.view';
